import React, { useEffect } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image/withIEPolyfill"

const Hero = ({ lang, isLangEn }) => {
  useEffect(() => {
    // Get correct height function with clearTimeout to prevent too many requests
    const vh = window.innerHeight * 0.01
    document.documentElement.style.setProperty("--vh", `${vh}px`)
    const currentWidth = window.innerWidth

    let timeoutId = null
    const resizeListener = () => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => {
        if (currentWidth !== window.innerWidth) {
          // get correct height
          const vh = window.innerHeight * 0.01
          document.documentElement.style.setProperty("--vh", `${vh}px`)
        }
      }, 500)
    }
    window.addEventListener("resize", resizeListener)

    return () => {
      window.removeEventListener("resize", resizeListener)
    }
  }, [])

  const { imgLogoJa } = useStaticQuery(graphql`
    query {
      imgLogoJa: file(relativePath: { eq: "logo-ja.png" }) {
        childImageSharp {
          fluid(maxWidth: 750) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `)

  return (
    <>
      <div className="parallax hero-bg"></div>
      <div className={`hero ${lang} font-serif`}>
        <h1 className="hero-logo font-headline only-for-small">
          {isLangEn ? (
            <>
              <div className="hero_en fadein delay1">
                Ema
                <br />
                Ryan
                <br />
                Yamazaki
              </div>
              <div className="hero_ja fadein delay3">
                <Img fluid={imgLogoJa.childImageSharp.fluid} alt="山崎エマ" />
              </div>
            </>
          ) : (
            <>
              <div className="hero_ja fadein delay1">
                <Img fluid={imgLogoJa.childImageSharp.fluid} alt="山崎エマ" />
              </div>
              <div className="hero_en fadein delay3">Ema Ryan Yamazaki</div>
            </>
          )}
        </h1>
      </div>
    </>
  )
}

export default Hero
